import { HeadingSkeleton } from 'modules/common/components/_ui/Skeletons/HeadingSkeleton/HeadingSkeleton'
import { Skeleton } from 'modules/common/components/_ui/Skeletons/Skeleton/Skeleton'

export const SponsorshipContainerSkeleton = () => {
  return (
    <div className="w-full max-w-[952px] space-y-12 p-12">
      <div className="flex flex-col items-center space-y-4">
        <HeadingSkeleton />
        <HeadingSkeleton className="w-96" />
      </div>
      <Skeleton className="my-12 h-[560px] w-full rounded-2xl" />
    </div>
  )
}
